<template>
  <div class="ArticlesBottom" :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']" style="lineHeight:20px">
    <p class="tit" >{{$t('Articles.Other')}}</p>
    <div class="ArticlesBottom_content" v-if="otherNews">
      <div
        v-for="(item,index) in otherNews.slice(0,4)"
        :key="index"
        class="ArticlesBottom_content_box"
        @click="toArticles(item.id)"
      >
        <div class="ArticlesBottom_content_img">
          <img :src="`${GLOBAL.imageUrl}${item.icon}`" alt />
        </div>

        <p class="ArticlesBottom_content_text">{{item.title}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  props: ["otherNews"],
  methods: {
    toArticles(id) {
      this.$router.push(`/articles?id=${id}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .ArticlesBottom {
    width: 1200px;
    padding-bottom: 30px;
    margin: 10px auto 0px;
    .tit {
      margin: 20px 0 20px;
      font-size: 16px;
      font-weight: 600;
      color: rgba(22, 72, 109, 1);
    }
    .ArticlesBottom_content {
      display: flex;
      flex-direction: row;
      .ArticlesBottom_content_box {
        cursor: pointer;
        width: 25%;
        height: 300px;
        padding: 10px 10px;
        display: flex;
        flex-direction: column;
        transition: 0.2s ease-in;
        border-radius: 4px;
        &:hover {
          transition: 0.2s ease-in;
          background: #ececec;
        }
        &:hover img {
          transition: 0.2s ease-in;
          transform: scale(1.1);
        }
        .ArticlesBottom_content_img {
          width: 100%;
          height: 200px;
          overflow: hidden;
          img {
            transition: 0.2s ease-in;
            object-fit: cover;
            width: 100%;
            height: 100%;
          }
        }
        .ArticlesBottom_content_text {
          margin-top: 20px;
          font-size: 16px;
          font-weight: 600;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .ArticlesBottom {
    width: 1200px;
    padding-bottom: 30px;
    margin: 10px auto 0px;
    .tit {
      margin: 20px 0 20px;
      font-size: 16px;
      font-weight: 600;
      color: rgba(22, 72, 109, 1);
    }
    .ArticlesBottom_content {
      display: flex;
      flex-direction: row;
      .ArticlesBottom_content_box {
        cursor: pointer;
        width: 25%;
        height: 300px;
        padding: 10px 10px;
        display: flex;
        flex-direction: column;
        transition: 0.2s ease-in;
        border-radius: 4px;
        &:hover {
          transition: 0.2s ease-in;
          background: #ececec;
        }
        &:hover img {
          transition: 0.2s ease-in;
          transform: scale(1.1);
        }
        .ArticlesBottom_content_img {
          width: 100%;
          height: 200px;
          overflow: hidden;
          img {
            transition: 0.2s ease-in;
            object-fit: cover;
            width: 100%;
            height: 100%;
          }
        }
        .ArticlesBottom_content_text {
          margin-top: 20px;
          font-size: 16px;
          font-weight: 600;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
    .ArticlesBottom {
    width: 100%;
    padding-bottom: 30px;
    margin: 10px auto 0px;
    .tit {
      margin: 20px 0 00px;
      padding: 10px;
      font-size: 16px;
      font-weight: 600;
      color: rgba(22, 72, 109, 1);
    }
    .ArticlesBottom_content {
      display: flex;
      flex-direction: column;
      .ArticlesBottom_content_box {
        cursor: pointer;
        width: 100%;
        height: 300px;
        padding: 10px 10px;
        display: flex;
        flex-direction: column;
        transition: 0.2s ease-in;
        border-radius: 4px;
    
        .ArticlesBottom_content_img {
          width: 100%;
          height: 200px;
          overflow: hidden;
          img {
            transition: 0.2s ease-in;
            object-fit: cover;
            width: 100%;
            height: 100%;
          }
        }
        .ArticlesBottom_content_text {
          margin-top: 20px;
          font-size: 16px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>